import { computedFn } from 'mobx-utils';
import { BasicOptionCheckState, ChoiceOptionState } from '../../../../classes/learnware/LearnwareEnums';
export class ChoiceOptionUI {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get option() {
        return this.parent;
    }
    get shouldOptionBeGreen() {
        return [
            ChoiceOptionState.CorrectDone,
            ChoiceOptionState.CorrectPending,
            ChoiceOptionState.ShouldHaveBeenSelected
        ].includes(this.choiceOptionUIState);
    }
    get choiceOptionUICheckState() {
        if (this.option.context.app.appInfo.isUserCurrentlyEditing) {
            return this.option.shouldBeSelected ? BasicOptionCheckState.Correct : BasicOptionCheckState.Default;
        }
        if (this.option.isCorrectlySelected)
            return BasicOptionCheckState.Correct;
        if (this.option.isWronglySelected)
            return BasicOptionCheckState.Wrong;
        return BasicOptionCheckState.Default;
    }
    get choiceOptionUIState() {
        if (this.option.context.app.appInfo.isUserCurrentlyEditing) {
            return this.option.shouldBeSelected ? ChoiceOptionState.CorrectPending : ChoiceOptionState.Default;
        }
        if (this.option.isCorrectlySelected && this.option.question.choiceEval.isComplete) {
            return ChoiceOptionState.CorrectDone;
        }
        if (this.option.isCorrectlySelected && !this.option.question.choiceEval.isComplete) {
            return ChoiceOptionState.CorrectPending;
        }
        if (this.option.isWronglySelected)
            return ChoiceOptionState.Wrong;
        if (this.option.question.choiceEval.isComplete && this.option.isOpenToBeSelected) {
            return ChoiceOptionState.ShouldHaveBeenSelected;
        }
        return ChoiceOptionState.Default;
    }
    shouldShowTemporaryFalseFeedback = computedFn((feedbackTime = 1500) => {
        const { latestSelection } = this.option.question.choiceSelections;
        if (!latestSelection)
            return false;
        if (latestSelection.selectedOption !== this.option)
            return false;
        if (!latestSelection.selectedOption.isWronglySelected)
            return false;
        return (this.option.context.app.appClock.clock_250.tickingTime <= latestSelection.selectionDate.getTime() + feedbackTime);
    });
    shouldShowTemporaryCorrectFeedback = computedFn((feedbackTime = 500) => {
        const { latestSelection } = this.option.question.choiceSelections;
        if (!latestSelection)
            return false;
        if (latestSelection.selectedOption !== this.option)
            return false;
        if (!latestSelection.selectedOption.isCorrectlySelected)
            return false;
        return (this.option.context.app.appClock.clock_250.tickingTime <= latestSelection.selectionDate.getTime() + feedbackTime);
    });
}
